import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import Select from 'react-select';
import CustomSnackbar from '../../../../Optics/Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { DeleteWifiPoint, UpdateAreaWifi, UpdateAzimuthWifi, UpdateControllerIpPointWifi, UpdateDescriptionPointWifi, UpdateHidEntranceWifiPoint, UpdateIpPointWifi, UpdateIpPortUplinkPointWifi, UpdateLoginPointWifi, UpdateMacPointWifi, UpdateModelWifiPoint, UpdatePasswordPointWifi, UpdatePlaneedWifiPoint, UpdateStatusWifiPoint, UpdateTypeWifiPoint } from '../../../WriteData/UpdateWifiCommunications';
import { loadingModelWifiData, loadingTypeWifiData, ValidateAndFormatIp, ValidateAndFormatMac } from '../../../Data/LoadingDataWifi';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '280px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
    
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '280px'
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const WifiDescriptEditingModal = ({ open, onClose, onClose2, content, wifiPointRefreshById, setIsComponentChangeCoorWifi, getWifiIcon}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [statusChange, setStatusChange] = useState(false);
  const [typeData, setTypeData] = useState([]);
  const [typeId, setTypeId] = useState("");
  const [modelId, setModelId] = useState("");
  const [ipPoint, setIpPoint] = useState(content.ip);
  const [statusChangeIpPoint, setStatusChangeIpPoint] = useState(false);
  const [macPoint, setMacPoint] = useState(content.mac);
  const [statusChangeMacPoint, setStatusChangeMacPoint] = useState(false);
  const [login, setLogin] = useState(content.login);
  const [statusChangeLoginPoint, setStatusChangeLoginPoint] = useState(false);
  const [password, setPassword] = useState(content.password);
  const [statusChangePasswordPoint, setStatusChangePasswordPoint] = useState(false);
  const [ipUplink, setIpUplink] = useState(content.uplinkIp);
  const [statusChangeIpUplink, setStatusChangeIpUplink] = useState(false);
  const [portUplink, setPortUplink] = useState(content.uplinkPort);
  const [statusChangePortUplink, setStatusChangePortUplink] = useState(false);
  const [controllerIp, setControllerIp] = useState(content.controllerIp);
  const [statusChangeControllerIp, setStatusChangeControllerIp] = useState(false);
  const [area, setArea] = useState(content.area);
  const [statusChangeArea, setStatusChangeArea] = useState(false);
  const [azimuth, setAzimuth] = useState(content.azimuth);
  const [statusChangeAzimuth, setStatusChangeAzimuth] = useState(false);
  const [statusPlanned, setStatusPlanned] = useState(false);
 const [hid, setHid] = useState(content.hid || '');
 const [entrance, setEntrance] = useState(content.entrance || '');
  

  

  const [fobId, setFobId] = useState("");
  const [modelData, setModelData] = useState([]);
  const [fobRankId, setFobRankId] = useState("");
  const [dividerData, setDividerData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [dividerId, setDividerId] = useState("");
  const [boxData, setBoxData] = useState([]);
  const [boxId, setBoxId] = useState("");
  const [polishingData, setPolishingData] = useState([]);
  const [polishingId, setPolishingId] = useState(content.polishingId);
  const [pigtailCount, setPigtailCount] = useState(content.pigtailCount);
  const [adapterCount, setAdapterCount] = useState(content.adapterCount);
  const [statusChangeAdapter, setStatusChangeAdapter] = useState(false);
  const [statusChangePigtail, setStatusChangePigtail] = useState(false);

  

  const handleChangeCoor= () => {
    handleCloseDialogs();
    setIsComponentChangeCoorWifi(true);
  }

   useEffect(() => {
      setStatusPlanned(content.planned === 1);
    }, [content.planned]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [typeData, modelWifi] = await Promise.all([
          loadingTypeWifiData(),
          loadingModelWifiData(),
        
        ]);
        setTypeData(typeData);
        setModelData(modelWifi);
       
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
    fetchData();
  }, []);

 
  
  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };
 
  


  
   const handleChangeTypeSelect = (event) => {
    const selectedType = event.target.value;
    if (selectedType === "") {
      setTypeId("");
    } else {
      const selectedType2 = typeData.find(type => 
        `${type.id}` === selectedType
      );
      if (selectedType2) {
        setTypeId(selectedType2.id);
      }
    }
  };

   const handleChangeModelSelect = (event) => {
    const selectedModel = event.target.value;
    if (selectedModel === "") {
      setModelId("");
    } else {
      const selectedModel2 = modelData.find(model => 
        `${model.id}` === selectedModel
      );
      if (selectedModel2) {
        setModelId(selectedModel2.id);
      }
    }
  };



  

  const updateTypePoint = () => {
  
    if (typeId === "") {
      showSnackbar('Type без изменений!', 'snackbarOk');
    } else {
       UpdateTypeWifiPoint(content.id, typeId, showSnackbar,content.authorId, wifiPointRefreshById );
    } 
  };

   const updateModelPoint = () => {
  
    if (modelId === "") {
      showSnackbar('Model без изменений!', 'snackbarOk');
    } else {
       UpdateModelWifiPoint(content.id, modelId, showSnackbar,content.authorId, wifiPointRefreshById );
    } 
  };

  const updatePointDescription = () => {
    if (statusChange) {
      UpdateDescriptionPointWifi(content.id, textComment, showSnackbar,content.authorId, wifiPointRefreshById);
    } else {
      showSnackbar('Текст без изменений!', 'snackbarOk');
    }
  };




  

   const handleIpPointChange = (event) => {
    const ip = ValidateAndFormatIp(event.target.value);
    setIpPoint(ip);

    if (ip !== content.ip) {
      setStatusChangeIpPoint(true);
    } else {
      setStatusChangeIpPoint(false);
    }
  };

   const handleAreaChange = (event) => {
    const area = event.target.value;
    setArea(area);

    if (area !== content.area) {
      setStatusChangeArea(true);
    } else {
      setStatusChangeArea(false);
    }
  };

  const handleHidChange = (e) => {
  setHid(e.target.value);
};

const handleEntranceChange = (e) => {
  setEntrance(e.target.value);
};


const updateHidEntrance = () => {
  if (!hid || !entrance) {
    showSnackbar('Ошибка: hid или entrance пустые', 'snackbarOk');
    return;
  }
  UpdateHidEntranceWifiPoint(content.id, hid, entrance, content.authorId, showSnackbar, wifiPointRefreshById, handleCloseDialogs );
};

  const handleMacPointChange = (event) => {
    const mac = ValidateAndFormatMac(event.target.value);
    setMacPoint(mac);

    if (mac !== content.mac) {
      setStatusChangeMacPoint(true);
    } else {
      setStatusChangeMacPoint(false);
    }
  };

  const handleLoginPointChange = (event) => {
    const login = event.target.value;
    setLogin(login);

    if (login !== content.login) {
      setStatusChangeLoginPoint(true);
    } else {
      setStatusChangeLoginPoint(false);
    }
  };

  const handlePasswordPointChange = (event) => {
    const password = event.target.value;
    setPassword(password);

    if (password !== content.password) {
      setStatusChangePasswordPoint(true);
    } else {
      setStatusChangePasswordPoint(false);
    }
  };

   const handleControllerIpPointChange = (event) => {
    const controllerIp = ValidateAndFormatIp(event.target.value);
    setControllerIp(controllerIp);

    if (controllerIp !== content.controllerIp) {
      setStatusChangeControllerIp(true);
    } else {
      setStatusChangeControllerIp(false);
    }
  };

 

  const handleIpUplinkChange = (event) => {
    const ip = ValidateAndFormatIp(event.target.value);
    setIpUplink(ip);

    if (ip !== content.ipUplink) {
      setStatusChangeIpUplink(true);
    } else {
      setStatusChangeIpUplink(false);
    }
  };

  const handlePortUplinkChange = (event) => {
    const port = event.target.value;
    setPortUplink(port);

    if (port !== content.portUplink) {
      setStatusChangePortUplink(true);
    } else {
      setStatusChangePortUplink(false);
    }
  };

   const handleAzimuthChange = (event) => {
    // Берём значение как строку
  let valueStr = event.target.value;

  // Убираем ведущие нули
  valueStr = valueStr.replace(/^0+(?=\d)/, '');

  // Преобразуем в число
  let value = parseInt(valueStr, 10);

  
  if (value < 0) value = 0;
  if (value > 359) value = 359;

  setAzimuth(value);

  if (value !== content.azimuth) {
    setStatusChangeAzimuth(true);
  } else {
    setStatusChangeAzimuth(false);
  }
  };



     const options = dividerData.map(divider => ({
        value: divider.id,  
        label: divider.model,
        group: divider.polishingId === 1 ? "UPC" : "APC", 
      }));
    
      // Группировка опций
      const groupedOptions = [
        {
          label: "UPC",
          options: options.filter(option => option.group === "UPC"),
        },
        {
          label: "APC",
          options: options.filter(option => option.group === "APC"),
        },
      ];

      const handleChangeDividerSelect = (selectedOption) => {
        if (!selectedOption) {
          setDividerId(""); 
          return;
        }  
      
        const selectedDivider = selectedOption.value; 
        
        const selectedDividerData = dividerData.find(divider => `${divider.id}` === `${selectedDivider}`);
        
        if (selectedDividerData) {
          setDividerId(selectedDividerData.id);
        }
      };

     


        const updateIpPoint = () => {
         if (statusChangeIpPoint) {
           UpdateIpPointWifi(content.id, ipPoint,content.authorId, showSnackbar, wifiPointRefreshById );
         } else {
           showSnackbar('IP без изменений!', 'snackbarOk');
         }
       };

        const updateMacPoint = () => {
         if (statusChangeMacPoint) {
           UpdateMacPointWifi(content.id, macPoint,content.authorId, showSnackbar, wifiPointRefreshById );
         } else {
           showSnackbar('MAC без изменений!', 'snackbarOk');
         }
       };

        const updateLoginPoint = () => {
         if (statusChangeLoginPoint) {
           UpdateLoginPointWifi(content.id, login, content.authorId, showSnackbar, wifiPointRefreshById );
         } else {
           showSnackbar('Login без изменений!', 'snackbarOk');
         }
       };

        const updatePasswordPoint = () => {
         if (statusChangePasswordPoint) {
           UpdatePasswordPointWifi(content.id, password, content.authorId, showSnackbar, wifiPointRefreshById );
         } else {
           showSnackbar('Password без изменений!', 'snackbarOk');
         }
       };

        const updateIpPortUplinkPoint = () => {
         if (statusChangeIpUplink ||statusChangePortUplink ) {
           UpdateIpPortUplinkPointWifi(content.id, ipUplink, portUplink, content.authorId, showSnackbar, wifiPointRefreshById );
         } else {
           showSnackbar('IP/PORT без изменений!', 'snackbarOk');
         }
       };

        const updateControllerIpPoint = () => {
         if (statusChangeControllerIp) {
           UpdateControllerIpPointWifi(content.id, controllerIp, content.authorId, showSnackbar, wifiPointRefreshById );
         } else {
           showSnackbar('Controller без изменений!', 'snackbarOk');
         }
       };

       const updateArea = () => {
         if (statusChangeArea) {
           UpdateAreaWifi(content.id, area,content.authorId, showSnackbar, wifiPointRefreshById, handleCloseDialogs );
         } else {
           showSnackbar('Area без изменений!', 'snackbarOk');
         }
       };

        const updateAzimuth = () => {
         if (statusChangeAzimuth) {
           UpdateAzimuthWifi(content.id, azimuth, content.authorId, showSnackbar, wifiPointRefreshById, handleCloseDialogs );
         } else {
           showSnackbar('Azimuth без изменений!', 'snackbarOk');
         }
       };

        // const deleteWifiPoint = () => {
        //    DeleteWifiPoint(content.id, showSnackbar, wifiPointRefresh, handleCloseDialogs);
        //  }; 

         const deleteWifiPoint = () => {
           UpdateStatusWifiPoint(content.id, showSnackbar, content.authorId, wifiPointRefreshById, handleCloseDialogs);
         }; 

          const handlePlannedCheckboxChange = () => {
             setStatusPlanned(!statusPlanned); 
            
             if(!statusPlanned){
               UpdatePlaneedWifiPoint(content.id, 1, showSnackbar, wifiPointRefreshById, content.authorId);
             }else{
               UpdatePlaneedWifiPoint(content.id, 0, showSnackbar, wifiPointRefreshById, content.authorId)
             }
             
           };

            const wifiTypeMap = {
              1: "PTP",
              2: "PTMP BASE",
              3: "CPE",
              4: "WIFI ZONE"
            };

      const groupedWifiModels = modelData.reduce((acc, item) => {
        const groupName = wifiTypeMap[item.wifiModelTypeId] || "Другое";

        if (!acc[groupName]) {
          acc[groupName] = [];
        }

        acc[groupName].push(item);
        return acc;
      }, {});
         
      

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
      <img
        src={getWifiIcon(content.wifiTypeId, content.planned)}
        width="30"
        height="30"
        style={{ marginRight: "5px" }}
      />

      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #080808ff'}}>Редактирование Wi-Fi</label>
       <label
          style={{
            color: content.planned === 1 ? '#ff5c5cff' : '#dfab01',
            fontSize: '20px',
            fontFamily: 'unset',
            marginLeft: '10px',
            textShadow: '2px 2px 4px #000000ff'
          }}
        >
      {content.planned === 1 ? '(Проектная)' : ''}
      </label>
       <hr className='hr-gradient'/>
      <label style={{ color: '#131313ff', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #080808ff' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#131313ff', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{content.canton} {content.region}</span> </label>
       <input
              type='text'
              className='textInputEditingModalWifi'
              min={0}
              value={area} 
              style={{width: '70px', fontSize: '14px'}}
              onChange={handleAreaChange} 
            /> 
            <button onClick={updateArea}  class='buttonIsSaveDialog2'>Сохранить</button>
            <br/>

      <label style={{ color: '#131313ff', fontWeight: 'bold'}}>ID дома/номер под.: </label>
            <input
                type="number"
                className="textInputEditingModalWifi"
                min={0}
                value={hid}
                style={{ width: '100px', fontSize: '14px' }}
                onChange={handleHidChange}
              />

              <input
                type="number"
                className="textInputEditingModalWifi"
                min={0}
                value={entrance}
                style={{ width: '60px', fontSize: '14px' }}
                onChange={handleEntranceChange}
              />

              <button onClick={updateHidEntrance} className="buttonIsSaveDialog2">
                Сохранить
              </button>

      <hr className='hr-gradient'/>
      <label style={{ color: '#000000ff', fontWeight: 'bold'}}>Проектная:</label>
          <input
            type="checkbox"
            checked={statusPlanned}
            onChange={handlePlannedCheckboxChange}
            style={{
              marginLeft: '10px',
              verticalAlign: 'middle',
            }}
      />  
      <br/>

     <label style={{ color: '#131313ff', fontWeight: 'bold', marginTop: '10px'}}>Тип: </label>

      <select className="textInputEditingModalWifi" style={{marginBottom: '10px', width:'150px'}} 

        onChange={(event) => {
          handleChangeTypeSelect(event);
        }} >
        <option value="">{content.wifiTypePoint}</option>
        {typeData.map(type => (
          <option key={type.id} value={type.id}>{type.type}</option>
        ))}
      </select>
      <button onClick={updateTypePoint} class='buttonIsSaveDialog2'>Сохранить</button>

       <br /> 
       <label style={{ color: '#131313ff', fontWeight: 'bold'}}>Модель: </label>

      <select className="textInputEditingModalWifi" style={{marginBottom: '10px', width:'320px'}} 

        onChange={(event) => {
          handleChangeModelSelect(event);
        }} >
        <option value="">{content.modelName}</option>
         {Object.entries(groupedWifiModels).map(([groupName, models]) => (
                <optgroup key={groupName} label={groupName}>
                  {models.map(model => (
                    <option key={model.id} value={model.id}>
                      {model.model}
                    </option>
                  ))}
                </optgroup>
              ))}
      </select>
      <button onClick={updateModelPoint} class='buttonIsSaveDialog2'>Сохранить</button>

    
       <div className="infoCard" style={{ display: "block", boxShadow: "0px 0px 6px 0px #000000ff" }}  
       >
         <label style={{ color: '#131313ff', fontWeight: 'bold'}}>Ip: </label>
       
            <input
              type='text'
              className='textInputEditingModalWifi'
              min={0}
              value={ipPoint} 
              style={{width: '120px', fontSize: '14px'}}
              onChange={handleIpPointChange} 
            /> 
            <button onClick={updateIpPoint}  class='buttonIsSaveDialog2'>Сохранить</button>
<br/>
               <label style={{ color: '#131313ff', fontWeight: 'bold'}}>Mac: </label>
       
            <input
              type='text'
              className='textInputEditingModalWifi'
              min={0}
              value={macPoint} 
              style={{width: '140px', fontSize: '14px'}}
              onChange={handleMacPointChange} 
            /> 
            <button onClick={updateMacPoint}  class='buttonIsSaveDialog2'>Сохранить</button>

            <br/>
               <label style={{ color: '#000000ff', fontWeight: 'bold'}}>Azimuth: </label>
       
            <input
              type="number"
              className='textInputEditingModalWifi'
              min={0}
              max={359}
              value={azimuth} 
              style={{width: '70px', fontSize: '14px'}}
              onChange={handleAzimuthChange} 
            /> 
            <button onClick={updateAzimuth}  class='buttonIsSaveDialog2'>Сохранить</button>
            <hr className="horizontalLineDialog2" /> 
             <label style={{ color: '#000000ff', fontWeight: 'bold'}}>Login: </label>
       
            <input
              type='text'
              className='textInputEditingModalWifi'
              min={0}
              value={login} 
              style={{width: '120px', fontSize: '14px'}}
              onChange={handleLoginPointChange} 
            /> 
            <button onClick={updateLoginPoint}  class='buttonIsSaveDialog2'>Сохранить</button>

            <br/>
             <label style={{ color: '#000000ff', fontWeight: 'bold'}}>Password: </label>
       
            <input
              type='text'
              className='textInputEditingModalWifi'
              min={0}
              value={password} 
              style={{width: '120px', fontSize: '14px'}}
              onChange={handlePasswordPointChange} 
            /> 
            <button onClick={updatePasswordPoint}  class='buttonIsSaveDialog2'>Сохранить</button>

     
      </div>

<div className="infoCard" style={{ display: "block", boxShadow: "0px 0px 6px 0px #000000ff", marginTop: '10px' }}
       >
 <label style={{ color: '#000000ff', fontWeight: 'bold'}}>Uplink: </label>
       
            <input
              type='text'
              className='textInputEditingModalWifi'
              min={0}
              value={ipUplink} 
              style={{width: '120px', fontSize: '14px'}}
              onChange={handleIpUplinkChange} 
            /> 
              <input
              type='number'
              className='textInputEditingModalWifi'
              min={0}
              value={portUplink} 
              style={{width: '70px', fontSize: '14px'}}
              onChange={handlePortUplinkChange} 
            /> 
            <button onClick={updateIpPortUplinkPoint}  class='buttonIsSaveDialog2'>Сохранить</button>
<br/>
 
             <label style={{ color: '#000000ff', fontWeight: 'bold'}}>Controller Ip: </label>
       
            <input
              type='text'
              className='textInputEditingModalWifi'
              min={0}
              value={controllerIp} 
              style={{width: '120px', fontSize: '14px'}}
              onChange={handleControllerIpPointChange} 
            /> 
            <button onClick={updateControllerIpPoint}  class='buttonIsSaveDialog2'>Сохранить</button>


       </div>
     
      <hr className='hr-gradient' style={{marginTop: "5px"}}/> 
      <label style={{ color: '#000000ff', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          style={{boxShadow:"0px 0px 6px 0px #000000ff"}}
          value={textComment} 
          onChange={handleDescriptionChange} 
        />

      <br/>
      <button onClick={updatePointDescription} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>

      <hr className="horizontalLineDialog2" style={{marginTop: '10px', marginBottom: '10px'}} /> 
      <button  class='buttonIsEditMarkerWifi' onClick={handleChangeCoor}> Редактировать на карте</button>

      <hr className='hr-gradient' style={{marginTop: '10px'}}/>

      <button 
          className="buttonIsDeleteModal" 
          onClick={deleteWifiPoint} 
          style={{ fontSize: "14px", width: "60px", padding: "2px" ,textShadow: '2px 2px 4px #3d3d3d'}}
        >
          Удалить
        </button>

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsCloseWifi' style={{width: '100%'}}>
            Закрыть
          </Button>
        </DialogActions>

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

    </Dialog>
  );
}

export default WifiDescriptEditingModal;